import { render, staticRenderFns } from "./voucherCancelado.vue?vue&type=template&id=5abaed18"
import script from "./voucherCancelado.vue?vue&type=script&lang=js"
export * from "./voucherCancelado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports